import React, { useState, } from 'react';
import { Button, Modal, ModalBody, ModalHeader, ModalFooter, FormGroup, Label, Input, } from 'reactstrap';
import { useToggle } from 'react-use';

import { scopes } from '../../shared/models/recurringExpense';

const { entries } = Object;

export default function RecurringExpenseScopeModal({ isOpen, title, submitLabel = 'OK', submitColor = 'primary', onSubmit, onClickClose, }) {
  const [scope, setScope] = useState('single');
  const [isSubmitting, toggleSubmitting] = useToggle(false);
  const handleSubmit = async () => {
    toggleSubmitting(true);
    await onSubmit(scope);
    toggleSubmitting(false);
  };

  return (
    <Modal isOpen={isOpen}>
      <ModalHeader>
        {title}
      </ModalHeader>
      <ModalBody>
        {
          entries(scopes).map(([key, { label }]) => (
            <FormGroup check key={key}>
              <Label check>
                <Input type="radio" name="recurringExpenseScope" checked={scope === key} onChange={_ => setScope(key)} />
                {label}
              </Label>
            </FormGroup>
          ))
        }
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" outline disabled={isSubmitting} onClick={onClickClose}>キャンセル</Button>
        <Button color={submitColor} outline disabled={isSubmitting} onClick={handleSubmit}>
          {isSubmitting && <span className="fas fa-spin fa-spinner me-1" />}
          {submitLabel}
        </Button>
      </ModalFooter>
    </Modal>
  );
};
